import {
  apply_grey_palette,
  applyMatrix,
  difs,
  greyscale_norm,
  matrix5,
  palette,
  rgb_bw
} from "../../../../shared/tools/image";

export type IPaletteType = 'nobg' | 'bg' | 'default';
export type IDifType = 'null' | 'full' | 'lite' | 'floyd' | 'sierra_lite';
export type InRGB = 'average' | 'luma' | 'srgb' | 'red' | 'green' | 'blue';

interface IProps {
  imageData: ImageData,
  paletteId?: IPaletteType,
  matrix?: string | string[],
  diffusion?: IDifType,
  grey?: InRGB,
  L?: boolean,
  G?: boolean,
  levels?: {gamma?: number, min?: number, max?: number},
}

export const getArt = async ({imageData, paletteId = 'default', diffusion = 'null', matrix = 'm1', grey='luma', L, G, levels}: IProps) => {

  let _img;
  let img_ = imageData;
  let _m = [];
  (typeof matrix === 'string') ? (_m = [matrix]) : (_m = matrix);

  _img = _m.reduce((a, b) => applyMatrix(img_, matrix5[b]), img_);

  _img = greyscale_norm(_img, rgb_bw[grey], levels, L, G);  // normalize
  const factors: Record<string, number> = {};

  let {img, counts, schema} = apply_grey_palette(_img, palette[paletteId], difs[diffusion]);

  let redraw = false;
  Object.keys(counts).forEach((key) => {
    if (counts[key] > 1160) {
      factors[key] = 1160 / counts[key];
      redraw = true;
    } else {
      factors[key] = 1;
    }
  })

  if (redraw) {
    return apply_grey_palette(_img, palette[paletteId], difs[diffusion], factors);
  }

  return ({img, counts, schema})
}
